import React from "react"
import {combineClasses} from "../../util/class-utils"
import marginStyles from "../../styles/shared-modules/margins.module.scss"

export const HeadingLarge: React.FC = ({ children}) => (
  <h1>{children}</h1>
)

export const HeadingMedium: React.FC = ({ children}) => (
  <h2>{children}</h2>
)

export const HeadingSmall: React.FC = ({ children}) => (
  <h3>{children}</h3>
)

export type HeadingSize = "small" | "medium" | "large"

const styleForSize: Record<HeadingSize, string> = {
  "large": marginStyles.DefaultLargeHeadingMargins,
  "medium": marginStyles.DefaultMediumHeadingMargins,
  "small": marginStyles.DefaultSmallHeadingMargins,
}

export interface HeadingProps {
  size: HeadingSize
  noSpacing?: boolean
  className?: string
}

export const Heading: React.FC<HeadingProps> = ({size, noSpacing = false, className, children}) => {
  const classNames = combineClasses([className, (noSpacing ? undefined : styleForSize[size])])

  switch (size) {
    case "large": return <h1 className={classNames}>{children}</h1>
    case "medium": return <h2 className={classNames}>{children}</h2>
    case "small": return <h3 className={classNames}>{children}</h3>
  }
}